<template>
  <div class="print-d" style="margin:auto;">
    <table class="report-table" border="1">
      <tr>
        <td colspan="25">
          <div>
            报名序号：{{data.EnrollNo}}
          </div>
          <div class="center large" style="margin:6px 0;">{{year}}年汕头金中海湾学校“天文地理特长生”自主招生报名信息表</div>
        </td>
      </tr>
      <tr>
        <td class="center first-col" style="width:13%;">姓名</td>
        <td class="center" colspan="3">{{data.FullName}}</td>
        <td class="center" colspan="2">性别</td>
        <td class="center" colspan="14">{{data.Sex==1?"男":"女"}}</td>
        <td class="center red bold small" rowspan="5" style="width:15%;">
          <el-image v-if="!loading" class="photo" :src="'/api'+data.PicUrl" fit="cover" :preview-src-list="['/api'+data.PicUrl]" style="height: 165px;width: 130px;margin-top: 6px;" />
        </td>
      </tr>
      <tr>
        <td class="center">身份证号</td>
        <td class="center" colspan="3">{{data.IdCard}}</td>
        <td class="center" colspan="2">户籍地</td>
        <td class="center" colspan="14">{{data.Domicile}}</td>
      </tr>
      <tr>
        <td class="center">中考报名号<br />(14位)</td>
        <td class="center" colspan="3">{{data.MiddleExamNo}}</td>
        <td class="center small pd-sm" colspan="2">就读学校所在<br/>区县</td>
        <td class="center" colspan="14">{{data.SchoolDistrict}}</td>
      </tr>
      <tr>
        <td class="center pd-sm">就读初中</td>
        <td class="center" colspan="19">{{data.MiddleSchool}}</td>
      </tr>
      <tr>
        <td class="center pd-sm">家长手机号码</td>
        <td class="center" colspan="19" style="height:40px;">{{data.Mobile}}</td>
      </tr>
      <tr>
        <td class="center">模式选择</td>
        <td class="center" colspan="24">
          <div style="padding-right:9rem;margin:auto;width:fit-content;">
            {{data.EnrollInfo55?"“64方案”模式":"“专项测试、面试”模式"}}
            <div class="zm dis" v-if="!data.EnrollInfo55">
              <el-upload
                action="/api/PoJunior9/UploadPictureInfo"
                :show-file-list="true"
                :file-list="InfoTestPicUrls"
                disabled>
              </el-upload>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="center bold" colspan="25">
          九年级成绩(本校初中毕业生人数，约 {{data.StudentNumber}} 人)
        </td>
      </tr>
      <tr>
        <td class="center">考试</td>
        <td class="center grade">语文</td>
        <td class="center grade">数学</td>
        <td class="center grade">英语</td>
        <td class="center grade">物理</td>
        <td class="center grade">化学</td>
        <td class="center grade">政治</td>
        <td class="center grade">历史</td>
        <td class="center grade">总分</td>
        <td class="center red bold print-black" colspan="16">综合成绩列年级(选填一项)</td>
      </tr>
      <tr>
        <td class="center">上学期期中</td>
          <td class="center">{{data.MidYw}}</td>
          <td class="center">{{data.MidSx}}</td>
          <td class="center">{{data.MidYy}}</td>
          <td class="center">{{data.MidWl}}</td>
          <td class="center">{{data.MidHx}}</td>
          <td class="center">{{data.MidZz}}</td>
          <td class="center">{{data.MidLs}}</td>
          <td class="center">{{total1}}</td>
          <td class="center bold print-black" colspan="15">{{data.MidSn==0?"前5%":(data.MidSn==1?"前30%":"30%后")}}</td>
      </tr>
      <tr>
        <td class="center">上学期期末</td>
          <td class="center">{{data.FinalYw}}</td>
          <td class="center">{{data.FinalSx}}</td>
          <td class="center">{{data.FinalYy}}</td>
          <td class="center">{{data.FinalWl}}</td>
          <td class="center">{{data.FinalHx}}</td>
          <td class="center">{{data.FinalZz}}</td>
          <td class="center">{{data.FinalLs}}</td>
          <td class="center">{{total2}}</td>
          <td class="center bold print-black" colspan="15">{{data.FinalSn==0?"前5%":(data.FinalSn==1?"前30%":"30%后")}}</td>
      </tr>
      <tr>
        <td class="center bold">下学期区<br class="only-print" />统考</td>
        <td class="center">{{data.UnifiedYw}}</td>
        <td class="center">{{data.UnifiedSx}}</td>
        <td class="center">{{data.UnifiedYy}}</td>
        <td class="center">{{data.UnifiedWl}}</td>
        <td class="center">{{data.UnifiedHx}}</td>
        <td class="center">{{data.UnifiedZz}}</td>
        <td class="center">{{data.UnifiedLs}}</td>
        <td class="center">{{total3}}</td>
        <td class="center bold print-black" colspan="15">{{data.UnifiedSn==0?"前5%":(data.UnifiedSn==1?"前30%":"30%后")}}</td>
      </tr>
      <tr>
        <td class="center" rowspan="3">承诺：</td>
        <td class="center" colspan="24">
          我们郑重承诺，以上所填内容完全真实准确。
          <br />否则，愿意承担取消报名资格或录取资格的后果。
        </td>
      </tr>
      <tr>
        <td class="center pd-sm" colspan="2">家长签名：</td>
        <td class="center bold" colspan="24">
          <el-image v-if="data.ParentSignUrl" :src="'/api'+data.ParentSignUrl" fit="contain" :preview-src-list="['/api'+data.ParentSignUrl]" style="height: 80px;width: 160px;" />
          <span v-else>(确认提交本信息表后，默认家长和考生签名完成!)</span>
        </td>
      </tr>
      <tr>
        <td class="center pd-sm" colspan="2">学生签名：</td>
        <td class="center" colspan="3">
          <el-image v-if="data.StudentSignUrl" :src="'/api'+data.StudentSignUrl" fit="contain" :preview-src-list="['/api'+data.StudentSignUrl]" style="height: 80px;width: 160px;" />
        </td>
        <td class="center" colspan="20" v-if="data.AddTime">{{toYMString(data.AddTime)}}</td>
        <td class="center" colspan="20" v-else>{{year}}年{{month}}月</td>
      </tr>
      <tr>
        <td class="bold" colspan="25">
          <span class="red print-black">特别提示：</span>
          <span class="blue">1、本表打印完成后，须在“电子彩照”位置贴上近期一寸彩照，并完成签名!!</span>
          <div class="blue" style="text-indent:5.3rem;">2、本表于参加报名时交给现场老师。</div>
        </td>
      </tr>
    </table>
    <div class="handle-button no-print">
      <el-button icon="el-icon-printer" size="mini" type="primary" @click="print">打印</el-button>
    </div>
  </div>
</template>
<script>
const date = new Date();
const year = date.getFullYear();
const month = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;

export default {
  beforeMount() {
    this.loading = true;
    var id = this.$route.query.id;
    this.api.info(id).then(res => {
      this.loading = false;
      if(res.Code==0) {
        if(res.Data) {
          // res.Data.InfoTestPicNames = "封面1.jpg,封面2.jpg";
          // res.Data.InfoTestPicUrls = "/Upload/Junior9/202305/c6bbc3bda49547448f0406a07e715641.jpg,/Upload/Junior9/202305/44439759c1c34f4a8bfdd0eb219720ae.jpg";
          this.data = res.Data;
          var urlArr = ["InfoTestPicUrls"];
          var urlArr2 = ["InfoTestPicNames"];
          urlArr.forEach((e,index) => {
            if(this.data[e]) {
              var arr = this.data[e].split(",");
              var arr2 = this.data[urlArr2[index]].split(",");
              arr.forEach((n,i) => {
                this[e].push({ url: n, name: arr2[i] });
              })
            }
          });
        }
      } else this.$message.error(res.Msg);
    });
  },
  computed: {
    total1() {
      var total = 0;
      var e = this.data;
      total += Number(e.MidYw);
      total += Number(e.MidSx);
      total += Number(e.MidYy);
      total += Number(e.MidWl);
      total += Number(e.MidHx);
      total += Number(e.MidZz);
      total += Number(e.MidLs);
      return Math.floor(total * 10) / 10;
    },
    total2() {
      var total = 0;
      var e = this.data;
      total += Number(e.FinalYw);
      total += Number(e.FinalSx);
      total += Number(e.FinalYy);
      total += Number(e.FinalWl);
      total += Number(e.FinalHx);
      total += Number(e.FinalZz);
      total += Number(e.FinalLs);
      return Math.floor(total * 10) / 10;
    },
    total3() {
      var total = 0;
      var e = this.data;
      total += Number(e.UnifiedYw);
      total += Number(e.UnifiedSx);
      total += Number(e.UnifiedYy);
      total += Number(e.UnifiedWl);
      total += Number(e.UnifiedHx);
      total += Number(e.UnifiedZz);
      total += Number(e.UnifiedLs);
      return Math.floor(total * 10) / 10;
    },
  },
  data() {
    return {
      api: require("@/api/po/junior9").default,
      data: {
        Junior9Id: 0,
        ParentId: 0,
        EnrollNo: "",
        FullName: "",
        Sex: null,
        IdCard: "",
        Domicile: "",
        MiddleExamNo: "",
        MiddleSchool: "",
        SchoolDistrict: "",
        Mobile: "",
        EnrollInfo: false,
        EnrollInfoTest: true,
        EnrollInfo55: false,
        EnrollQct: false,
        //------------
        StudentNumber: null,
        MidYw: null,
        MidSx: null,
        MidYy: null,
        MidWl: null,
        MidHx: null,
        MidZz: null,
        MidLs: null,
        MidSn: null,
        FinalYw: null,
        FinalSx: null,
        FinalYy: null,
        FinalWl: null,
        FinalHx: null,
        FinalZz: null,
        FinalLs: null,
        FinalSn: null,
        UnifiedYw: null,
        UnifiedSx: null,
        UnifiedYy: null,
        UnifiedWl: null,
        UnifiedHx: null,
        UnifiedZz: null,
        UnifiedLs: null,
        UnifiedSn: null,
        QualityScore: null,
        //------------
        PicUrl: "",
        ParentSignUrl: "",
        StudentSignUrl: "",
        InfoTestPicUrls: "",
        InfoTestPicNames: "",
        Status: 0,
        AddTime: "",
      },
      InfoTestPicUrls: [],
      loading: false,
      year,
      month,
    };
  },
  methods: {
    toDateString(v) {
      if(!v) return "";
      var date = this.$commonJs.toDateString(v);
      var arr = date.split("/");
      return arr[0] + "年" + arr[1] + "月" + arr[2] + "日";
    },
    toYMString(v) {
      if(!v) return "";
      var date = this.$commonJs.toDateString(v);
      var arr = date.split("/");
      return arr[0] + "年" + arr[1] + "月";
    },
    print() {
      window.print();
    }
  }
};
</script>
<style lang="scss" scoped>
.print-d {
  width: 1100px;
  padding: 10px 0;
}
.handle-button {
  position: fixed;
  top: 10px;
  right: 30px;
}
.report-table {
  font-family: "宋体","微软雅黑";
  border-spacing: 0;
  border-collapse: collapse;
  width: 100%;
  font-size: 16px;
  td {
    padding: 6px 8px;
  }
  .center {
    text-align: center;
  }
  .right {
    text-align: right;
  }
  .red {
    color: #f11;
  }
  .blue {
    color: #11f;
  }
  .small {
    font-size: 14px;
  }
  .large {
    font-size: 20px;
  }
  .grade {
    width: 7%;
  }
  .only-print {
    display: none;
  }
}
.zm {
  font-size: 16px;
  /deep/ .el-upload-list__item-name {
    color: #000;
  }
}
/deep/ .dis .el-upload {
  display: none;
}
/deep/ .el-upload-list__item-status-label {
  display: none !important;
}
/deep/ .el-upload-list__item-name {
  margin-right: 0 !important;
}
@media print {
  .print-d {
    width: calc(100% - 2px);
    padding: 0;
  }
  .no-print {
    display: none;
  }
  .only-print {
    display: block !important;
  }
  .wl {
    width: 25.5% !important;
  }
  .pd-sm {
    padding: 2px !important;
  }
  .lv {
    width: 15% !important;
  }
  .zs {
    width: 19.5% !important;
  }
  .photo {
    height: 155px !important;
  }
  .zs-img {
    margin-top: 4px !important;
    height: 80px !important;
  }
  .print-black {
    color: #000 !important;
  }
  .first-col {
    width: 19% !important;
  }
}
</style>